module.exports = window["$.imagesLoaded"];